import ButtonLink from '@/components/links/ButtonLink';
import useLocale from 'next-translate/useTranslation';
import Image from 'next/image';

export default function Certifications({ reverse = false }: { reverse?: boolean }) {
  const { t } = useLocale('home');

  return (
    <div className='bg-white py-24 dark:bg-slate-900 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='grid grid-cols-1 items-center gap-x-8 gap-y-8 lg:grid-cols-2 lg:gap-x-16'>
          <div className={`mx-auto w-full max-w-xl lg:mx-0 ${reverse ? 'lg:order-2' : ''}`}>
            <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-white'>
              Marianna OLEFYRENKO<br />
              <span className='text-2xl text-gray-600 dark:text-gray-400'>
                CEO | Co-Founder
              </span>
              
            </h2>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
            Agentic AI Expert, Agile Enthusiast, Google Developer Group Member from 2019
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
            15+ years in IT across AI, Software Engineering, Data Analytics, and UX/UI Marianna builds end‑to‑end, user‑centric products that turn complex AI into practical outcomes for businesses. She blends product strategy with hands‑on engineering to ship resilient, measurable solutions.
            
            </p>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
            Technical focus and stack
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
            Marianna builds with JavaScript/TypeScript across Node.js and React/Next.js, and works extensively in data and ML using SQL (Postgres/BigQuery), Pandas, GA4, and Mixpanel—along with LLMOps practices such as prompt design, evaluation, RAG/retrieval pipelines, and vector databases. She deploys on GCP, uses CI/CD with GitHub Actions, and grounds delivery in strong Product/UX methods.
            </p>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
             5+ years of experience as a trainer
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
            Product & AI Practitioner, WSQ Advanced Certificate in Learning and Performance 2.0 (ACLP 2.0). Marianna delivers practical workshops on prompt engineering, agentic AI, and AI adoption for teams.
            </p>
           
            
          </div>
          <div className={`flex h-full w-full items-center justify-center ${reverse ? 'lg:order-1' : ''}`}>
            <div className="flex h-full w-full flex-col items-center justify-center gap-10">
            <div className="flex flex-col gap-10 w-full lg:flex-row">
              <Image
                className="w-full h-[32rem] object-contain lg:w-1/2"
                src="/images/about-us/ACLP_Cert.png"
                alt="ALCP Certification"
                width={1200}
                height={512}
                priority
              />
              <Image
                className="w-full h-[32rem] object-contain lg:w-1/2"
                src="/images/about-us/ISCA.png"
                alt="ISCA"
                width={1200}
                height={512}
                priority
              />
            </div>

              <Image
                className="w-full h-[32rem] object-contain"
                src="/images/about-us/NTU_AI.png"
                alt="NTU AI"
                width={1200}
                height={512}
                priority
              /> 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
